    <template>
<div>


<Toolbar class="contenttopbar">
<template #start>
<h3 class="text-primary mb-2 mt-2 font-medium">{{$store.state.languages.lang_phrases.soru_listesi_bolumleri}}</h3>
</template>
<template #end>

<div class="hide_on_mobile">

<span class="p-input-icon-right">
  <template v-if="searchterm!==''">    
    <i class="pi pi-times" @click="clearSearch" v-if="!is_searching"/>
    <i class="pi pi-spin pi-spinner" v-if="is_searching" />
  </template>
  <template v-else>
    <i class="pi pi-search" />
  </template>
  
  <InputText type="text" v-model="searchterm"  class="w-full p-inputtext-sm mb-0" @input="searchTermChanged" placeholder="Arama" @keydown.esc="clearSearch"/>
</span>
</div>

<div class="hide_on_mobile"><Button type="button" class="p-button-primary p-button-outlined p-button-sm ml-2" :label="$store.state.languages.lang_phrases.yeni_bolum_ekle" icon="pi pi-plus" @click="gotoPage('QuestionlistsNewSection')" /></div>

<div class="hide_on_mobile"><Button type="button" class="p-button-primary p-button-outlined p-button-sm ml-2" :label="$store.state.languages.lang_phrases.toplu_islem" icon="pi pi-list" @click="openBatchEdit" /></div>
<div class="hide_on_mobile"><Button type="button" class="p-button-primary p-button-outlined p-button-sm ml-2" :label="$store.state.languages.lang_phrases.on_izleme" icon="pi pi-eye" @click="openPreview" /></div>

<div class="show_on_mobile"><Button type="button" class="p-button-primary p-button-outlined p-button-sm ml-2"  icon="pi pi-plus" @click="gotoPage('QuestionlistsNewSection')" /></div>

<div class="show_on_mobile"><Button type="button" class="p-button-primary p-button-outlined p-button-sm ml-2"  icon="pi pi-list" @click="openBatchEdit" /></div>
<div class="show_on_mobile"><Button type="button" class="p-button-primary p-button-outlined p-button-sm ml-2"  icon="pi pi-eye" @click="openPreview" /></div>
</template>
</Toolbar>  

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>
<template v-if="!loading">
<br/>

<template v-if="searchresults">
  <h2 class="text-primary bold">Bölümler</h2>
  <LineItem v-for="element in searchresults.sections" :line="element" type="section" :highlightterm="searchterm"></LineItem>
<hr>

  <h2 class="text-primary bold">Sorular</h2>
  <LineItem v-for="element in searchresults.inputfields"  :line="element" type="inputfield" :highlightterm="searchterm"></LineItem>
</template>
<template v-else>
  <SortableArray :list="sections" groupname="sections" type="section" :datacontainer="{id:0}"></SortableArray>
</template>



<br/><br/><br/><br/><br/><br/>
</template>
<QuestionlistBatchEditModal ref="batcheditmodal" @batchedited="batchedited"></QuestionlistBatchEditModal>
</div>
</template>

<script>
import QuestionlistBatchEditModal from "./QuestionlistBatchEditModal"
export default {

  name: 'QuestionlistQuestions',

  data () {
    return {
    	loading:true,
    	sections:[],
      searchterm:"",
      is_searching:false,
      searchinterval:null,
      searchresults:null,
    }
  },
  components:{QuestionlistBatchEditModal},
  mounted()
  {
  	this.$store.dispatch('ui/setActiveTab',"sorular") 
  	this.$store.dispatch('suppliers/setUploadPage',"questions") 
  	
  	this.getData()
  },
  computed:{
  	deletedstate()
  	{
  		return this.$store.state.ui.deletedstate
  	}
  },
  watch:{
  	deletedstate(newVal,oldVal)
  	{
  		if(newVal)
  		{
        console.log("list delete state")
  			this.getData()
  		}
  	},
    searchterm(newVal)
    {
      if(newVal!=="")
      {
        this.is_searching = true
      }
      else
      {
         this.is_searching = false
      }
    }
  },
  methods:{
    searchTermChanged()
    {
      clearInterval(this.searchinterval);
      this.searchinterval = setInterval(()=>{
        this.searchTerm()
      },1000)
    },
    clearSearch()
    {
      clearInterval(this.searchinterval);
       this.is_searching = false
       this.searchterm = ""
       this.searchresults = null
    },
    searchTerm()
    {
      clearInterval(this.searchinterval);
      if(this.searchterm=="")
      {
        this.searchresults = null
        this.is_searching = false

        return false
      }
      let formdata = new FormData()
      formdata.append("searchterm",this.searchterm)
      formdata.append("questionlist_id",this.$route.params.id)
      this.silentSubmission(formdata,"questionlist/search_term",this.afterSearchTerm)
    },
    afterSearchTerm(response)
    {
      console.log("afterSearchTerm")
      console.log(response.data)
      this.is_searching = false
      this.searchresults = response.data

    },
    batchedited()
    {
      this.getData()
    },
  	async getData()
  	{
  		this.sections = await this.generalApiGetWithoutLoader("questionlists/sections/"+this.$route.params.id)
  		await console.log(this.sections);
      let sections = await this.generalApiGetWithoutLoader("questionlist_sections/"+this.$route.params.id)
      let inputfields = await this.generalApiGetWithoutLoader("questionlist_inputfields/"+this.$route.params.id)
      await this.$store.dispatch('questionlists/setInputfields',inputfields)
      await this.$store.dispatch('questionlists/setSections',sections) 
  		this.loading = await false
  	},
    openPreview()
    {
      window.open(process.env.VUE_APP_APP_ROOT+"/"+this.$store.state.auth.user.uuid+"/questionlist_preview/"+this.$store.state.questionlists.questionlist.id, '_blank').focus();
    },
    openBatchEdit()
    {
      this.$refs.batcheditmodal.showModal()
    },
  }
};
</script>

<style lang="css" scoped>
</style>